import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { RadioCircle } from '@components/radio-button';
import { useFormContext } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { Item } from '@/vacancy_request/components/template-request-form/options-group/styled';
import { useTranslationWithPrefix } from '@/i18n/hooks';
import { HrParagraph, HrRed } from '@components/styles/hr-styles';

const OptionsList = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 32px;
`;

export const OptionsGroup = (props) => {
  const { name, label, options, disabled, isOptionDisabled } = props;

  const { t } = useTranslationWithPrefix('requestVacancies.requestTemplate.form.options');
  const { register, watch, formState } = useFormContext();
  const selectedValue = watch(name);
  const { errors } = formState;

  return (
    <Item>
      {label}
      <OptionsList>
        {options.map((option) => (
          <RadioCircle
            key={option.value}
            name={name}
            text={t(option.traduction)}
            value={option.value}
            checked={String(option.value) === String(selectedValue)}
            register={register}
            disabled={disabled || isOptionDisabled(option.value)}
          />
        ))}
      </OptionsList>
      <ErrorMessage
        errors={errors}
        name={name}
        render={({ message }) => <HrParagraph color={HrRed}>{message}</HrParagraph>}
      />
    </Item>
  );
};

OptionsGroup.propTypes = {
  name: PropTypes.string.isRequired,
  // Node y no string: los campos custom pasan una fila con el nombre, la pregunta y sus acciones.
  label: PropTypes.node.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  disabled: PropTypes.bool,
  isOptionDisabled: PropTypes.func
};

OptionsGroup.defaultProps = {
  disabled: false,
  isOptionDisabled: () => false
};
